import { getState } from '../../reduxService';
import user from './user/userSlice';
import DynamicReducers from '../Dynamic/store/reducers';
import projectInfo from './projectInfo/projectInfoSlice';
import formControlReducer from './form/formControlSlice';
import componentiGraficiSlice from '../Dynamic/store/project/componentiGraficiSlice';
import authReducer from './auth/authSlice';

export default {
    user,
    projectInfo,
    Dynamic: DynamicReducers,
    formControl: formControlReducer,
    componentiGrafici: componentiGraficiSlice,
    auth: authReducer,
};

export const getUser = () => getState().user;
export const getDynamic = () => getState().Dynamic;
export const getProjectInfo = () => getState().projectInfo;
export const getFormControl = () => getState().formControl;
export const getComponentiGrafici = () => getState().componentiGrafici;
export const getAuth = () => getState().auth;
